import { Button, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material'
import React, { ReactNode, useEffect, useState } from 'react'
import GenerateIcon from './GenerateIcon'
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';

export interface IBasicModalWindowButton {
    label: string,
    variant?: 'text' | 'outlined' | 'contained',
    color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning',
    onClick?: () => void,
    handleClose?: boolean,
    disabled?: boolean
}

export interface IBasicModalWindow {
    shown: boolean,
    title?: string,
    message?: string,
    showHeader?: boolean,
    size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | "fullscreen",
    actionButtons: Array<IBasicModalWindowButton>,
    actionButtonsBottom?: boolean,
    handleClose: () => void,
    pageOverlayStyle?: boolean,
}

interface IProps extends IBasicModalWindow {
    children: ReactNode
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
      children: React.ReactElement<unknown>;
    },
    ref: React.Ref<unknown>,
  ) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

const BasicModalWindow: React.FC<IProps> = ({ children, ...props }) => {

    const { shown, title, message, size, actionButtons, showHeader, handleClose, pageOverlayStyle, actionButtonsBottom } = props

    const baseContainerClassName: string = `basic-modal-window-container ${size} ${pageOverlayStyle ? "page-window-style" : "default-style"}`
    const [containerClassName, setContainerClassName] = useState<string>(baseContainerClassName)

    /**
     * Shown status
     */
    useEffect(() => {
        if (shown){
            setContainerClassName(baseContainerClassName + " active")
        }else{
            setContainerClassName(baseContainerClassName)
        }
    }, [shown])

    /**
     * Render action buttons
     */
    const renderActionButtons = () => {
        return actionButtons.map((button, index) => <Button key={index} disabled={button.disabled} color={button.color ? button.color : "inherit"} onClick={() => {
            if (button.onClick){
                button.onClick()
            }

            if (button.handleClose){
                handleClose()
            }
}} className={"general-button admin-style"} variant={button.variant ? button.variant : "text"} >{button.label}</Button>)
    }

    /**
     * Render header
     */
    const renderHeader = () => {
        return(
            <AppBar className="default-mui-app-bar" sx={{ position: 'relative' }}>
                <Toolbar>

                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>

                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                        {title}
                    </Typography>
                
                    {!actionButtonsBottom && renderActionButtons()}

                </Toolbar>
            </AppBar>
        )
    }

    const renderTitle = () => {
        if (!title) {
            return <></>
        }
        
        return(
                <DialogTitle>
                    {title}
                </DialogTitle>
        )
    }

    return(
        <Dialog
            fullScreen={size === "fullscreen" ? true : false}
            open={shown}
            onClose={handleClose}
            TransitionComponent={Transition}
            style={{ 
                zIndex: 99999
             }}
            maxWidth={size === "fullscreen" ? "lg" : size}
            fullWidth
        >
            {size === "fullscreen" ? renderHeader() : renderTitle()}

            {size === "fullscreen" ? (
                <div className="mui-dialog-main-content-container">
                    <div className="content-of-mui-dialog-main-content-container">
                        {children}
                    </div>
                </div>
            ) : (
                <DialogContent>
                    <div style={{ paddingTop: 10 }}>
                        {children}
                    </div>
                </DialogContent>
            )}

            {actionButtonsBottom && (
                <DialogActions>
                    {renderActionButtons()}
                </DialogActions>
            )}
        </Dialog>
    )

    return(
        <div className={containerClassName}>
            <div className="content-of-basic-modal-window-container">

                <div className="basic-modal-window-box">
                    <div className="content-of-basic-modal-window-box">

                        {showHeader && (
                            <div className="header-of-basic-modal-window-box">
                                <div className="content-of-header-of-basic-modal-window-box">
                                    {title &&   <h3>
                                                    {pageOverlayStyle && <IconButton onClick={() => handleClose()} style={{ marginRight: 10, marginTop: -5 }}><GenerateIcon icon="back" /></IconButton>}
                                                    {title}
                                                </h3>}
                                    {message && <p>{message}</p>}
                                </div>
                            </div>
                        )}

                        <div className="content-wrapper-of-basic-modal-window-box">
                            <div className="content-of-content-wrapper-of-basic-modal-window-box">
                                {children}
                            </div>
                        </div>

                        <div className="action-buttons-of-basic-modal-window-box">
                            <div className="content-of-action-buttons-of-basic-modal-window-box">
                                {actionButtons.map((button, index) => <Button key={index} disabled={button.disabled} color={button.color ? button.color : "inherit"} onClick={() => {
                                    if (button.onClick){
                                        button.onClick()
                                    }

                                    if (button.handleClose){
                                        handleClose()
                                    }
                            }} className={"general-button admin-style"} variant={button.variant ? button.variant : "text"} >{button.label}</Button>)}
                            </div>
                        </div>

                    </div>
                </div>

            </div>
            <div className="mask-of-basic-modal-window"></div>
        </div>
    )
}

export default BasicModalWindow